export default "__VITE_ASSET__CwHI6frj__"